// Dónde se abre el popover del análisis, sin React
// (ADR-2026-09-09-el-popover-nunca-queda-cortado).
//
// Vive aparte del componente porque el bug que arregla era ARITMÉTICO: la versión anterior,
// al no entrar abajo, se tiraba arriba **sin comprobar que arriba entrara**, y lo anclaba por
// `bottom`. Un popover más alto que el espacio disponible se salía por arriba de la ventana,
// y al ser `fixed` no hay scroll que lo alcance: el contenido quedaba inaccesible.

export const ANCHO_POPOVER = 320;
export const MARGEN_POPOVER = 8;
/** Alto mínimo utilizable cuando no entra ni arriba ni abajo. */
export const ALTO_MINIMO_POPOVER = 180;

export interface Ventana {
  ancho: number;
  alto: number;
}

/** Lo que el popover necesita del ancla: su caja en coordenadas de ventana. */
export interface CajaAncla {
  top: number;
  bottom: number;
  left: number;
}

export interface PosicionPopover {
  top: number;
  left: number;
  /** Tope de alto con scroll propio; `undefined` cuando el popover entra completo. */
  maxAlto?: number;
}

/**
 * Siempre por `top`, nunca por `bottom`: con `bottom`, un popover más alto que el hueco de
 * arriba se sale de la ventana sin que la cuenta lo note.
 *
 * Orden: abajo si entra, arriba si entra, y si no entra en ningún lado va del lado con más
 * aire, pegado al borde y con scroll propio. Nunca devuelve un `top` negativo.
 */
export function posicionDelPopover(p: {
  ancla: CajaAncla;
  altoContenido: number;
  ventana: Ventana;
}): PosicionPopover {
  const { ancla, altoContenido, ventana } = p;
  const left = Math.min(
    Math.max(MARGEN_POPOVER, ancla.left),
    Math.max(MARGEN_POPOVER, ventana.ancho - ANCHO_POPOVER - MARGEN_POPOVER),
  );
  const abajo = ventana.alto - ancla.bottom - MARGEN_POPOVER;
  const arriba = ancla.top - MARGEN_POPOVER;

  if (altoContenido <= abajo) return { top: ancla.bottom + MARGEN_POPOVER, left };
  if (altoContenido <= arriba) return { top: ancla.top - MARGEN_POPOVER - altoContenido, left };

  const haciaAbajo = abajo >= arriba;
  return {
    top: haciaAbajo ? ancla.bottom + MARGEN_POPOVER : MARGEN_POPOVER,
    left,
    maxAlto: Math.max(ALTO_MINIMO_POPOVER, haciaAbajo ? abajo : arriba),
  };
}
